var site = site || {};

site.gotL2Cache = false;

(function ($) {
  var topSellersV1 = {
    $template: $('.top-sellers-v1'),

    init: function () {
      var self = this;

      self.$template.each(function () {
        var $me = $(this);

        // re-draw with L2 cache
        $(document).on('inventory_status_stored', function () {
          topSellersV1.cleanAndDisplay($me);
          site.gotL2Cache = true;
        });

        // if we already have L2 cache...
        if (site.gotL2Cache) {
          topSellersV1.cleanAndDisplay($me);
        }
      });
    },
    cleanAndDisplay: function ($me) {
      // Default 3-column
      var columns = 3;
      var displayMppSoldOut = Drupal.settings.globals_variables.display_mpp_sold_out;
      var displayMppTos = Drupal.settings.globals_variables.display_mpp_tos;
      var inventoryStatus;

      // Uncomment for testing 3-column when using 5-column as test data
      // $me.removeClass('columns-5').addClass('columns-3');

      // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
      $(page_data['product-input-type'].products).each(function (i, product) {
        if (typeof product.skus !== 'undefined') {
          var isOrderableSku = $(product.skus).filter(function () {
            if (typeof $(document).data(this.SKU_ID) != 'undefined') {
              inventoryStatus = $(document).data(this.SKU_ID).INVENTORY_STATUS;

              return ($(document).data(this.SKU_ID).isOrderable == 1) || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3);
            }
          })[0];
          var isDisplayableSku = $(product.skus).filter(function () {
            var undef;
            var sku = $(document).data(this.SKU_ID);

            return typeof site.features.spp_displayable_status !== 'undefined'
            && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
          })[0];

          if (typeof isOrderableSku == 'undefined' && !isDisplayableSku &&
             (!displayMppSoldOut && inventoryStatus === 7 || !displayMppTos && inventoryStatus === 2)) {
            // remove product - removed completely so the quickshop positioning remains correct
            $me.find('.product[data-productid="' + product.PRODUCT_ID + '"]').parents('li').remove();
          } else {
            $me.find('.product[data-productid="' + product.PRODUCT_ID + '"]').addClass('hasValidSku');
          }
        }
      });
      // remove those that lack any skus, let alone any valid ones...
      // $me.find('.product[data-productid]').not('.hasValidSku').parents('li').remove();

      // 5-column
      if ($me.hasClass('columns-5')) {
        columns = 5;
      }

      // Set up rows
      var $items = $me.find('li'),
        $iLen = $items.length;

      for (var i = 0; i < $iLen; i += columns) {
        $items.slice(i, i + columns).wrapAll('<div class="row"></div>');
      }

      $('img').on('load', function() {
        matchHeight();
      });
      $(window).resize(function () {
        matchHeight();
      });
      function matchHeight() {
      // Set the height of the columns within each row
        $me.find('.row').each(function () {
          var $cols = $(this).find('li'),
            ch = 0;

          $cols.each(function () {
            var $el = $(this);

            $el.css({ height: 'auto' });
            var h = $el.outerHeight(true);

            if (h > ch) {
              ch = h;

              return;
            }
          }).height(ch);
        });
      }
      $items.each(function (i) {
        $(this).prepend('<div class="number">' + (i + 1) + '</div>');

        // The brand needs a way to "globally" adjust the product titles width.
        // The main problem is that implementing any "global" fix will apply to
        // all product titles, including the ones that already have line breaks (<br>)
        // in it and that could make some product titles (with <br>) look worse.
        // TODO: For any "global" solution we'll need to do a clean up of the existent product
        // titles (remove all <br> from product titles) and adjust the product titles
        // via CSS only.
        // WORKAROUND: Look for product titles without any <br> tags in it and override its
        // default max-width (set to 160px bellow) while ignoring any product title
        // that contains one or more <br> tags in it.
        var prodTitle = $(this).find('.product .product-info .product-title'),
          prodTitleHtml = prodTitle.find('a').html(),
          prodTitleBr = prodTitle.find('a br'),
          maxWidth = '160px'; // Maybe this can be set through CMS in a field

        if (prodTitleBr.length === 0) {
          prodTitle.css({ 'max-width': maxWidth });
        }
      });
    }
  };

  $(window).on('load', function() {
    topSellersV1.init();
  });
})(jQuery);
